module.exports = __webpack_public_path__ + "static/img/gen_root3.4086c0b1.jpg";